function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-09423bd9-cdb4-4be8-a234-bccff02581a5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.247,5.997c.327,0,.656.108.93.331l10.506,8.526c.346.28.546.702.546,1.147s-.201.867-.546,1.147l-10.506,8.526c-.633.514-1.564.417-2.078-.216-.514-.634-.417-1.564.216-2.078l9.092-7.379-9.092-7.379c-.634-.514-.73-1.444-.216-2.078.292-.359.718-.546,1.148-.546Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/Forward.81b368b12510b2509bb1398163682fd5.svg";
export { ForwardRef as ReactComponent };